"use strict";
var Observable_1 = require('../../Observable');
var fromPromise_1 = require('../../observable/fromPromise');
Observable_1.Observable.fromPromise = fromPromise_1.fromPromise;
//# sourceMappingURL=fromPromise.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/observable/fromPromise.js
 ** module id = 411
 ** module chunks = 2
 **/